module.exports = __webpack_public_path__ + "static/media/mailerlite-icon.205cf919.svg";